/* src/app/shared/components/pager/pager.component.scss */
:host {
  display: inline-block;
  flex-grow: 0;
  flex-shrink: 0;
  justify-content: center;
  word-spacing: -100%;
}
.pagination .btn {
  border-radius: 0;
}
.pagination .btn:focus,
.pagination .btn:hover,
.pagination .btn:active {
  border-radius: 0;
}
.pagination .btn:focus::before {
  border-radius: 0;
}
.pagination .page-item:first-child .btn:focus,
.pagination .page-item:first-child .btn:hover,
.pagination .page-item:first-child .btn:active {
  border-radius: 5px 0 0 5px;
}
.pagination .page-item:first-child .btn:focus::before {
  border-radius: 5px 0 0 5px;
}
.pagination .page-item:last-child .btn:focus,
.pagination .page-item:last-child .btn:hover,
.pagination .page-item:last-child .btn:active {
  border-radius: 0 5px 5px 0;
}
.pagination .page-item:last-child .btn:focus::before {
  border-radius: 0 5px 5px 0;
}
/*# sourceMappingURL=pager.component.css.map */
